/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export const SHOW_SPINNER = 'SHOW_SPINNER';

export const HIDE_SPINNER = 'HIDE_SPINNER';
